'use strict';

import * as Redux from 'redux';

//const My = require('../reducers/my');
import SigninOrRegister from './reducers/signin-or-register.js';

import Login from '../../login/reducers/login.js';
import Register from '../../signup/reducers/register.js';
import Forgot from '../../login/forgot/reducers/forgot.js';


export default Redux.createStore(
    Redux.combineReducers({
        //my: My,
        signinOrRegister: SigninOrRegister,
        login: Login,
        register: Register,
        forgot: Forgot
    })
);
